/**
 * Scopes storefront search to product title, tag and product type.
 *
 * Shopify's unscoped search runs the query through its semantic layer, which
 * returns "related" products rather than matches — searching "socks" returned 12
 * products, only 2 of which were socks. A field-prefixed query bypasses that
 * layer entirely and matches literally. The `options[fields]` parameter does not
 * help; it is ignored for unscoped queries.
 *
 * Mirrors snippets/search-scope-query.liquid — change both together.
 */
(function () {
  'use strict';

  var SCOPED_MARKER = 'title:';
  var OPERATORS = /^(and|or|not)$/i;
  var HAS_ALPHANUMERIC = /[\p{L}\p{N}]/u;

  function scopeQuery(raw) {
    var words = String(raw || '').trim().split(/\s+/);
    var groups = [];

    for (var i = 0; i < words.length; i++) {
      // Strip the characters Shopify treats as search operators so a shopper
      // typing them cannot produce a malformed query.
      var word = words[i].replace(/[():*"]/g, '').trim();
      if (!word || OPERATORS.test(word)) continue;

      // Skip pure punctuation. Every group is AND-ed, so an "&" left standing
      // in "Purple & Red" would match nothing and zero out the whole search.
      if (!HAS_ALPHANUMERIC.test(word)) continue;

      var branches = fieldsFor(word);

      // Prefix matching is left-anchored, so "socks*" misses a product titled
      // "...SOCK". Add the singular stem so plural queries still find it. The
      // typed word stays first — search-display-terms.liquid reads that branch
      // to render what the shopper typed.
      if (word.length > 3 && /s$/i.test(word)) {
        branches = branches.concat(fieldsFor(word.slice(0, -1)));
      }

      groups.push('(' + branches.join(' OR ') + ')');
    }

    return groups.join(' AND ');
  }

  function fieldsFor(word) {
    return ['title:' + word + '*', 'tag:' + word + '*', 'product_type:' + word + '*'];
  }

  // Rewrite the value in the capture phase, before the browser serializes the
  // form. The page navigates away immediately, so the swap is never visible.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || typeof form.matches !== 'function') return;
      if (!form.matches('form[action$="/search"]')) return;

      var input = form.querySelector('input[name="q"]');
      if (!input || input.value.indexOf(SCOPED_MARKER) !== -1) return;

      var scoped = scopeQuery(input.value);
      if (scoped) input.value = scoped;
    },
    true
  );

  // Backstop: a raw ?q= can still reach /search from a bookmark, a shared link,
  // an app or a browser search suggestion. Rewrite it once so those visitors get
  // the same literal results as everyone else.
  if (/^\/search/.test(window.location.pathname)) {
    var params = new URLSearchParams(window.location.search);
    var raw = params.get('q');

    if (raw && raw.indexOf(SCOPED_MARKER) === -1) {
      var scoped = scopeQuery(raw);
      if (scoped && scoped !== raw) {
        params.set('q', scoped);
        window.location.replace(window.location.pathname + '?' + params.toString());
      }
    }
  }
})();
